import React from 'react';

// Stylized logo: a play triangle made of vertical equalizer bars
const Logo = ({ size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Trillex logo"
    >
      {/* Triangle clip via mask */}
      <defs>
        <clipPath id="triClip">
          <polygon points="6,6 6,34 34,20" />
        </clipPath>
      </defs>
      <g clipPath="url(#triClip)">
        <rect x="6" y="10" width="3.2" height="20" fill="#ffffff" />
        <rect x="11" y="6" width="3.2" height="28" fill="#ffffff" />
        <rect x="16" y="9" width="3.2" height="22" fill="#ffffff" />
        <rect x="21" y="12" width="3.2" height="16" fill="#ffffff" />
        <rect x="26" y="15" width="3.2" height="10" fill="#ffffff" />
      </g>
      <line x1="6" y1="36" x2="34" y2="36" stroke="#ffffff" strokeWidth="1.2" />
    </svg>
  );
};

export default Logo;
